<template>
  <fragment>
    <div class="form-group">
      <div class="card-body">
        <label class="fontWeight">Comment:</label>
        <app-input class="col-sm-8"
                   type="textarea"
                   v-model="comment.action_comment"
                   placeholder="Write Comment"
                   :required="true"/>
        <p class="fontStyle">
          <span class="fontWeight">Status: </span>
          {{ comment.status }}
        </p>
        <fragment v-for="(file, fileIndex) in comment.applicant_files" :key="fileIndex">
          <p>{{ file.name }}</p>
          <a target="_blank" :href="`/${file.fileURL}`" class="btn btn-primary"> View</a>
          <a href="#"
             class="btn btn-danger el-button--default float-left"
             @click.prevent="remove(fileIndex, file.id)">
            Remove
          </a>
        </fragment>
      </div>
      <div class="card-footer">
        <multi-upload-btn
            :uploadedFile="this.uploadedFile"
            :emailAddress="this.emailAddress"
        />
      </div>
    </div>
    <div class="form-group">
      <el-button class="secondary float-left ml-3 mt-2"
                 @click="saveComment()">
        Save Comment
      </el-button>
      <el-button class="secondary float-left ml-3 mt-2"
                 @click="close()">
        Close
      </el-button>
    </div>
  </fragment>
</template>

<script>
import {Comment, File} from "@Views/Screening/utility/apiAgent";
import {updateCommentSteps} from "@Views/Screening/utility/common/comment";

export default {
  name: "CustomizedGeneralComment",
  props: {
    comment: {
      type: Object,
      required: true
    },
    applicantId: {
      type: Number,
    },
    emailAddress: {
      type: String
    },
    steps: {
      type: Array
    }
  },
  data() {
    return {
      uploadedFile: [],
    };
  },
  methods: {
    updateCommentSteps,
    saveComment() {
      if (this.comment.action_comment != '') {
        const commentObj = {
          id: this.comment.id,
          action_comment: this.comment.action_comment,
          status: this.comment.status,
          statusable_type: this.comment.statusable_type,
          statusable_id: this.comment.statusable_id,
          applicant_files: this.comment.applicant_files,
        };
        Comment.editComment(this.applicantId, this.comment.id, commentObj)
            .then(({data}) => {
              this.comment = {...commentObj};
              this.updateCommentSteps(commentObj, false);
              this.$toastr.s(data.message);
            });
      }
    },
    remove(fileIndex, applicantFileId) {
      File.deleteDocument(applicantFileId)
          .then(({data}) => {
            this.comment.applicant_files.splice(fileIndex, 1);
            this.$toastr.s(data.message);
          });
    },
    close() {
      this.$emit('close-comment-listing', false);
    }
  },
  watch: {
    uploadedFile: {
      handler: function (file) {
        this.$set(this.comment.applicant_files, this.comment.applicant_files.length, file);
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.direction-input {
  direction: ltr;
}

.direction-label {
  text-align: left;
}

.fontStyle {
  font-size: 12px;
}

.errorStyle {
  font-weight: bolder;
  color: red;
}

.fontWeight {
  font-weight: bolder
}
</style>